import { getCookie } from '../cookieHelpers';
import { CLASS_ANSWERS, CLASS_FOOTER_NOTICE, sessionData } from './enquiryCommons';
import showLoginLink from './showLoginLink';
import loadResults from './loadResults';
import handleVote from './handleVote';

/**
 * @name enquiryBars
 * @description Zobrazí ankety, každá po jedné otázce s pruhovými odpověďmi.
 * Jednotlivá anketa může nabývat několika stavů. Pokud uživatel není přihlášen, zobrazí se po hlasování výzva k přihlášení.
 * Výsledky hlasování se zobrazí až po přihlášení a tedy přesměrování z Porty, stránka zascrolluje k anketě, ve které uživatel hlasoval.
 * Pokud uživatel přihlášen je, zobrazí se přímo výsledky hlasování. V tomto případě se použijí data vrácená jako odpověď na zaslání hlasu na BE.
 *
 * @param {NodeListOf<HTMLElement>} enquiries Jednotlivé ankety.
 */
export const enquiryBars = (enquiries) => {
  enquiries.forEach(async (enquiry) => {
    const { enquiryId } = enquiry.dataset;
    const isLogged = Boolean(enquiry.dataset.isLogged);
    const enquiryVotingDisabled = Boolean(enquiry.dataset.enquiryVotingDisabled);
    const question = enquiry.querySelector('[data-question-id]');
    const answersWrapper = enquiry.querySelector(`.${CLASS_ANSWERS}`);
    const voteNotice = enquiry.querySelector(`.${CLASS_FOOTER_NOTICE}`);
    const { questionId, questionText } = question.dataset;
    const answers = enquiry.querySelectorAll('[data-answer-id]');
    const selectedAnswerCookie = getCookie(`enquiry-${questionId}`);

    // Pokud uživatel vybral odpověď, existuje cookie s uloženou odpovědí, případně hodnotou 'votingEnded', pokud hlasování skončilo.
    if (selectedAnswerCookie) {
      // Pokud je uživatel přihlášen, zobrazí se výsledky odpovědí. Pokud ne, tak výzva k přihlášení.
      if (isLogged) {
        // Pokud se uživatel vrací z externího přihlášení (porty) zascrolluje se k anketě, ze které na přihlášení odešel.
        if (sessionData.getItem('userLoggingFrom') === questionId) {
          enquiry.scrollIntoView();
          sessionData.removeItem('userLoggingFrom');
        }

        // Pokud hlasování skončilo, zobrazí se výsledky v twigové šabloně, není třeba je volat.
        if (selectedAnswerCookie !== 'votingEnded') {
          await loadResults(
            enquiry.dataset.enquiryId,
            questionId,
            answers,
            voteNotice,
            selectedAnswerCookie
          );
        }
      } else {
        showLoginLink(
          enquiry,
          answersWrapper,
          voteNotice,
          questionId,
          questionText,
          enquiryVotingDisabled
        );
      }
    } else if (!isLogged || !enquiryVotingDisabled) {
      // Pokud je uživatel přihlášen a zároveň anketa skončila, výsledek se zobrazí ve twigové šabloně.
      // Pokud uživatel nehlasoval, nastaví se anketa (statická HTML šablona) tak, aby hlasovat mohl.
      answersWrapper.addEventListener('click', async function voteHandlerListener(event) {
        await handleVote(
          isLogged,
          enquiryVotingDisabled,
          enquiry,
          enquiryId,
          questionId,
          questionText,
          answersWrapper,
          answers,
          voteNotice,
          voteHandlerListener,
          event
        );
      });
    }
  });
};
